export const fields = {
	optionalLeft: ['Student ID', 'Birth Date', 'Race and Ethnicity', 'Lunch Status'],
	optionalRight: ['Gifted/Talented', 'SPED', 'RTI', 'ELL/ESL', '504'],
	required: ['Student’s First and Last Name', 'Grade Level', 'Language', 'Gender'],
}
